import * as React from "react"
import { Card } from "reactstrap"

function MyCard() {

  return (
    <Card className="mb-3 p-2">
		📧 lenagabinskayardn@gmail.com
		<br/>📞 (404) 884-2886
    </Card>
  )
}

export default MyCard
